import {
  APP_OUTDATED,
} from '../actions/app-outdated';

const INITIAL_STATE = {
  isMounted: false,
  isOutdated: false,
  isNavVisible: false,
  loginRedirect: '/home-page',
  settings: {
    environmentVariables: {},
  },
};

export default function app(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'app/mounted':
      return {
        ...state,
        isMounted: true,
      };

    case APP_OUTDATED:
      return {
        ...state,
        isOutdated: payload.isOutdated,
      };

    case 'login/redirect':
      return {
        ...state,
        loginRedirect: payload,
      };
    case 'app/logout': {
      console.log('NIce One');
      return {
        INITIAL_STATE
      }
    }  
    case 'clearStorage': {
      console.log('NIce One 1', INITIAL_STATE);
      return {
        INITIAL_STATE
      }
    }  

    default:
      return state;
  }
}
